import { Container, Tabs, rem } from "@mantine/core";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthProvider";
import { getVisibleTabsForRole } from "../../config/operationsTabs";
import { ROUTES } from "../../constants/routes";

export const OperationsNav: React.FC = () => {
  const { userRole } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Get tabs visible to current user role
  const visibleTabs = userRole ? getVisibleTabsForRole(userRole) : [];

  // Extract current tab from URL path
  const getActiveTab = (): string => {
    const pathParts = location.pathname.split("/");
    const tabFromPath = pathParts[pathParts.length - 1];

    // Map some specific paths to tab IDs
    switch (tabFromPath) {
      case "certificates":
      case "technologies":
      case "education":
      case "languages":
      case "roles":
      case "companies":
      case "officelocations":
        return "dictionaries";
      case "chat-about-candidates":
        return "chat-about-candidates";
      case "notification-testing":
        return "notification-testing";
      case "ai-management":
        return "ai-management";
      default:
        return tabFromPath || "cv-management";
    }
  };

  // Handle tab change
  const handleTabChange = (value: string | null) => {
    if (value) {
      navigate(ROUTES.OPERATIONS_WITH_PATH(value));
    }
  };

  return (
    <Container size="xl" py="md">
      <Tabs value={getActiveTab()} onChange={handleTabChange}>
        <Tabs.List>
          {visibleTabs.map((tab) => (
            <Tabs.Tab
              key={tab.id}
              value={tab.id}
              leftSection={
                <tab.icon style={{ width: rem(16), height: rem(16) }} />
              }
            >
              {tab.label}
              {tab.badge && <span className="ml-2 badge">{tab.badge}</span>}
            </Tabs.Tab>
          ))}
        </Tabs.List>
      </Tabs>
    </Container>
  );
};
